import { get, isUndefined, memoize } from 'lodash'

function handlebars (text: string, context: Record<string, any> = {}, delimiter: string = '"') {
  return text.replace(
    compileRegExp(delimiter),
    (_: string, key: string, defaultString: string = ''): string => {
      const value = get(context, key)
      return !isUndefined(value) && String(value) || unescape(defaultString)
    }
  )
}

const compileRegExp = memoize(
  (d: string) => {
    /* tslint:disable-next-line */
    return new RegExp(String.raw`{{\s*([\w\d\.-]+)(?:(?:\s*:\s*)(?:${d}((?:\\${d}|[^${d}])*)${d}))?\s*}}`, 'gi')
  }
)

/**
 * Escape any escape characters in string.
 * @param string The string to escape.
 */
const unescape = (string: string) => {
  return string.replace(/\\(.)/gi, '$1')
}

export default handlebars
export {
  handlebars,
  unescape,
}
